import { render } from "./SobrePage.vue?vue&type=template&id=4702092b&scoped=true"
import script from "./SobrePage.vue?vue&type=script&lang=js"
export * from "./SobrePage.vue?vue&type=script&lang=js"

import "./SobrePage.vue?vue&type=style&index=0&id=4702092b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4702092b"]])

export default __exports__